function handleAssetsUrl(url) {
  if (!url) return '';
  if (url.indexOf('http') === 0) {
      return url;
  }
  let reg = /^\//;
  let qiniuAssetsUrl = 'https://resources.laihua.com';

  let reg2 = new RegExp(qiniuAssetsUrl + '/', 'g');
  url = url.replace(reg2, '');
  if (!reg.test(url)) {
      return qiniuAssetsUrl + '/' + url;
  } else {
      return qiniuAssetsUrl + url;
  }
}

class SoundPlayHandle {
  constructor() {
    this.currentTime = 0;
    this.totalTime = 10;
    this.isPlay = false;
    this.musicVolume = 100;
    this.dubbingVolume = 100;
    this.music = [];
    this.musicPlayData = [];
    this.dubbing = [];
    this.dubbingPlayData = [];
    this.startTime = 0;
    this.nowTime = 0;
    this.startNode = 0;
    this.playFrame = null;
    this.musicLoop = false;
    this.stackOfDelete = [];
  }

  loopMusic (music) {
    music = JSON.parse(JSON.stringify(music));
    this.music.length = 0;
    for (let i = 0; i < music.length;i++) {
      this.music[i] = music[i];
      this.loadSound(this.music[i], 'music');
    }
    this.needUpdateMusic = true;
    this.updateMusicPlayData();
  }
  addMusic(music, index, noUpdate = false) {
    let musicObject = JSON.parse(JSON.stringify(music));
    this.loadSound(musicObject, 'music');
    if (typeof index === 'number') {
      this.music.splice(index, 0, musicObject);
    } else {
      this.music.push(musicObject);
    }
    this.updateMusicPlayData(noUpdate);
  }
  delMusic(index, noUpdate = false) {
    if(this.music[index]) {
      this.music[index].ele = null;
      this.music.splice(index, 1);
      this.updateMusicPlayData(noUpdate);
    }
  }
  updateMusic(music, index, noUpdate = false) {
    let old = this.music[index];
    if(!old) return;
    let needLoad = music.url && music.url !== old.url;
    Object.assign(old, JSON.parse(JSON.stringify(music)));
    if(needLoad) {
      if(old.ele) {
        old.load = false;
        old.ele.src = handleAssetsUrl(music.url);
        old.ele.load();
        old.ele.onloadedmetadata = () => {
          old.load = true;
          old.ele.currentTime = old.cut[0];
          old.ele.onloadedmetadata = null;
        }
      } else {
        this.loadSound(old, 'music')
      }
    }
    this.updateMusicPlayData(noUpdate);
  }
  addDubbing(dubbing, index, noUpdate = false) {
    let dubbingObject = JSON.parse(JSON.stringify(dubbing));
    this.loadSound(dubbingObject, 'dubbing');
    if (typeof index === 'number') {
      this.dubbing.splice(index, 0, dubbingObject);
    } else {
      this.dubbing.push(dubbingObject);
    }
    this.updateDubbingPlayData(noUpdate);
  }
  addDubbingGroup(dubbingArr = [], index, delNum = 1) {
    let arr = [];
    let dubbingObj = null;
    for(let i = 0; i < dubbingArr.length; i++) {
      dubbingObj = JSON.parse(JSON.stringify(dubbingArr[i]));
      this.loadSound(dubbingObj, 'dubbing')
      arr.push(dubbingObj);
    }
    if(typeof index === 'number') {
      this.dubbing.splice(index, delNum, ...arr)
    } else {
      this.dubbing.splice(this.dubbing.length, 0, ...arr)
    }
    this.updateDubbingPlayData();
  }
  delDubbing(index, noUpdate = false) {
    if(this.dubbing[index]) {
      this.dubbing[index].ele = null;

        console.log(`Turbo ~ SoundPlayHandle ~ delDubbing ~ new Error().stack`, new Error().stack);
        this.stackOfDelete.push({
            data: this.dubbing[index],
            stack: new Error().stack
        });

      this.dubbing.splice(index, 1);
      this.updateDubbingPlayData(noUpdate);
    }
  }
  updateDubbing(dubbing, index, noUpdate = false) {
    let old = this.dubbing[index];
    if(!old) return;
    let needLoad = dubbing.url && dubbing.url !== old.url;
    Object.assign(old, JSON.parse(JSON.stringify(dubbing)));
    if(needLoad) {
      if(old.ele) {
        old.load = false;
        old.ele.src = handleAssetsUrl(dubbing.url);
        old.ele.load();
        old.ele.onloadedmetadata = () => {
          old.load = true;
          old.ele.currentTime = old.cut[0];
          old.ele.onloadedmetadata = null;
        }
      } else {
        this.loadSound(old, 'dubbing')
      }
    }
    this.updateDubbingPlayData(noUpdate);
  }

  loadSound(sound, type) {
    sound.load = false;
    if(!sound.url) return;
    const audioEle = document.createElement('audio');
    audioEle.onerror = () => {
      sound.load = false;
      sound.ele = null;
    }
    audioEle.oncanplay = () => {
      audioEle.oncanplay = null;
      audioEle.currentTime = sound.cut[0];
    }
    audioEle.src = handleAssetsUrl(sound.url);
    audioEle.volume = this[`${type}Volume`] / 100;
    audioEle.loop = false || this.musicLoop;
    audioEle.load();
    sound.load = true;
    sound.ele = audioEle;
    sound.playing = false;
  }


  updateMusicPlayData(noUpdate = false) {
    if(noUpdate) return;
    this.musicPlayData.length = 0;
    for(let i = 0; i < this.music.length; i++) {
      this.musicPlayData.push(...this.music[i].timeSlot)
    }
  }
  updateDubbingPlayData(noUpdate = false) {
    if(noUpdate) return;
    this.dubbingPlayData.length = 0;
    for(let i = 0; i < this.dubbing.length; i++) {
      this.dubbingPlayData.push(...this.dubbing[i].timeSlot)
    }
  }
  playMusic(time, reset) {
    let num = -1,
      index = 0,
      music = null,
      leftTime = 0;
    for(let i = 0; i < this.musicPlayData.length; i++) {
      if(time > this.musicPlayData[i]) {
        num++;
        leftTime = this.musicPlayData[i];
      } else {
        break;
      }
    }
    index = parseInt(num / 2);
    for(let i = 0; i < this.music.length; i++) {
      music = this.music[i];
      if(!music.ele) continue;
      if (music.ele.loop) {
        if (music.ele.currentTime < music.cut[0] || music.ele.currentTime > music.cut[1]) {
          music.ele.currentTime = music.cut[0];
        }
      }
      if(i < index) {
        if(music.playing) {
          music.ele.pause()
          music.playing = false;
        }
      } else if(i == index) {
        if(num % 2) {
          if(music.playing) {
            music.ele.pause();
            music.playing = false;
          }
        } else {
          if(!music.playing || reset) {
            leftTime = this.musicPlayData[num] || 0;
            music.ele.currentTime = time - leftTime + music.cut[0];
            if (music.ele.loop) {
              let dur = music.cut[1] - music.cut[0];
              let nLine = Math.floor(time / dur);
              let yets = time -  dur * nLine + music.cut[0];
              music.ele.currentTime = yets;
            }
            music.ele.play();
            music.playing = true;
          }
        }
      } else {
        break;
      }
    }
  }
  pauseMusic() {
    for(let i = 0; i < this.music.length; i++) {
      if(!this.music[i].ele || !this.music[i].playing) continue;
      this.music[i].ele.pause();
      this.music[i].playing = false;
    }
  }
  playDubbing(time, reset) {
    let num = -1,
      index = 0,
      dubbing = null,
      leftTime = 0;
    for(let i = 0; i < this.dubbingPlayData.length; i++) {
      if(time > this.dubbingPlayData[i]) {
        num++;
        leftTime = this.dubbingPlayData[i];
      } else {
        break;
      }
    }
    index = parseInt(num / 2);
    for(let i = 0; i < this.dubbing.length; i++) {
      dubbing = this.dubbing[i];
      if(!dubbing.ele) continue;
      if(i < index) {
        if(dubbing.playing) {
          dubbing.ele.pause()
          dubbing.playing = false;
        }
      } else if(i == index) {
        if(num % 2) {
          if(dubbing.playing) {
            dubbing.ele.pause();
            dubbing.playing = false;
          }
        } else {
          if(!dubbing.playing || reset) {
            leftTime = this.dubbingPlayData[num] || 0;
            dubbing.ele.currentTime = time - leftTime + dubbing.cut[0];
            dubbing.ele.play();
            dubbing.playing = true;
          }
        }
      } else {
        break;
      }
    }
  }
  pauseDubbing() {
    for(let i = 0; i < this.dubbing.length; i++) {
      if(!this.dubbing[i].ele || !this.dubbing[i].playing) continue;
      this.dubbing[i].ele.pause();
      this.dubbing[i].playing = false;
    }
  }
  play(data) {
    // {isplay, time} isplay是否正在播放，time播放开始的时间（单位秒）
    if(this.isPlay) {
      if(data.isPlay) {
        this.startTime = data.time;
        this.startNode = 0;
      } else {
        this.pauseMusic();
        this.pauseDubbing();
        this.isPlay = false;
        window.cancelAnimationFrame(this.playFrame);
      }
    } else {
      if(data.isPlay) {
        this.startNode = 0;
        this.startTime = data.time;
        this.isPlay = true;
        this.playFrame = window.requestAnimationFrame((timestamp) => {
          this.stepPlay(timestamp)
        })
      }
    }
  }
  stepPlay(timestamp){
    let reset = false;
    if(!this.startNode) {
      this.startNode = timestamp;
      reset = true;
    }
    this.nowTime = (timestamp - this.startNode) / 1000 + this.startTime;
    this.playMusic(this.nowTime, reset);
    this.playDubbing(this.nowTime, reset);
    this.playFrame = window.requestAnimationFrame((timestamp) => {
      this.stepPlay(timestamp)
    })
  }
  changeVolume(type, volume) {
    let sounds = this[type];
    this[`${type}Volume`] = volume;
    for(let i = 0; i < sounds.length; i++) {
      if(!sounds[i].ele) continue;
      sounds[i].ele.volume = volume / 100;
    }
  }
  changePreviewVolume(volume) {
    let dubbingVolume = this.dubbingVolume * volume / 100 / 100;
    let musicVolume = this.musicVolume * volume / 100 / 100;
    for(let i = 0; i < this.dubbing.length; i++) {
      if(!this.dubbing[i].ele) continue;
      this.dubbing[i].ele.volume = dubbingVolume;
    }
    for(let i = 0; i < this.music.length; i++) {
      if(!this.music[i].ele) continue;
      this.music[i].ele.volume = musicVolume;
    }
  }
  dubbingText(data) {
    // 批量设置配音的text
    for(let i = 0; i < this.dubbing.length; i++) {
      for(let j = 0; j < data.length; j++) {
        if(this.dubbing[i].url === data[i].url) {
          this.dubbing[i].text = data[i].text;
          break;
        }
      }
    }
  }
  // 生成json
  toJson(totalTime) {
    let music = {
      volume:[this.dubbingVolume,this.musicVolume,100],
      data: [],
      musicLoop: this.musicLoop,
      stackOfDelete: this.stackOfDelete
    };
    for(let i = 0; i < this.music.length; i++) {
      let value = Object.assign({}, this.music[i]);
      value.timeSlot = [...this.music[i].timeSlot];
      let pre = this.music[i-1];
      if(pre && pre.timeSlot[1] - value.timeSlot[0] >= 0.002) {
        this.delMusic(i, false);
        i--;
        continue;
      }
      if(value.timeSlot[1] > totalTime) {
        if(value.timeSlot[0] <= totalTime - 0.2) {
          value.timeSlot[1] = totalTime;
        } else {
          break;
        }
      }
      let sound = {
        title: value.title,
        resourceId: value.id,
        type: 2,
        fileType: value.fileType,
        url: value.url,
        timeSlot: value.timeSlot.map(v => {return + v.toFixed(3)}),
        cut: value.cut.map(v => {return + v.toFixed(3)}),
        startEffect: value.startEffect,
        endEffect: value.endEffect,
      }
      music.data.push(sound);
    }
    for(let i = 0; i < this.dubbing.length; i++) {
      let value = Object.assign({}, this.dubbing[i]);
      value.timeSlot = [...this.dubbing[i].timeSlot];
      let pre = this.dubbing[i-1];
      if(pre && pre.timeSlot[1] - value.timeSlot[0] >= 0.002) {
        this.delDubbing(i, false);
        i--;
        continue;
      }
      if(value.timeSlot[1] > totalTime) {
        if(value.timeSlot[0] <= totalTime - 0.2) {
          value.timeSlot[1] = totalTime;
        } else {
          break;
        }
      }
      let sound = {
        title: value.title,
        resourceId: value.id,
        type: 1,
        fileType: value.fileType,
        url: value.url,
        timeSlot: value.timeSlot.map(v => {return + v.toFixed(3)}),
        cut: value.cut.map(v => {return + v.toFixed(3)})
      }
      music.data.push(sound)
    }
    return music
  }
  // 加载json
  fromJson(json) {
    this.stackOfDelete = json.stackOfDelete || [];
    this.dubbingVolume = (json.volume || {})[0] || 50;
    this.musicVolume = (json.volume || {})[1] || 50;
    this.musicLoop = !!json.musicLoop;
    // this.musicVolume = json.volume[0];
    // this.dubbingVolume = json.volume[1];
    let music = [],
        dubbing = [];
    this.dubbing.length = 0;
    this.music.length = 0;
    for(let i = 0; i < json.data.length; i++) {
      let sound = json.data[i];
      let obj = {
        title: sound.title,
        id: sound.resourceId,
        fileType: sound.fileType,
        url: sound.url,
        timeSlot: [...sound.timeSlot],
        cut: [...sound.cut],
        startEffect: sound.startEffect,
        endEffect: sound.endEffect
      }
      if(sound.type === 1) {
        dubbing.push(obj)
      }else if(sound.type === 2) {
        music.push(obj)
      }
    }
    music.sort(function(a, b) {
      return a.timeSlot[0] - b.timeSlot[0];
    })
    dubbing.sort(function(a, b) {
      return a.timeSlot[0] - b.timeSlot[0];
    })
    music.forEach(sound => {
      this.addMusic(sound, undefined, true)
    })
    dubbing.forEach(sound => {
      this.addDubbing(sound, undefined, true)
    })
    this.updateMusicPlayData();
    this.updateDubbingPlayData();
  }

  // 以下代码是操作场景页的方法=========
  clearSound(type) {
    while(this[type].length) {
      let sound = this[type].pop()
      sound.ele = null;
    }
    if(type === 'dubbing') {
      this.updateDubbingPlayData();
    } else {
      this.updateMusicPlayData();
    }
  }
  delScenesSound(ct) {
    let dub = null;
    let dur = ct[1] - ct[0];
    let index = -1;
    let addDub = {};
    for(let i = 0; i < this.dubbing.length; i++) {
      dub = this.dubbing[i];
      // ___ |----|--- 在删除时间段的前面
      if(dub.timeSlot[1] <= ct[0]) continue;
      // ----|----| ___ 在删除时间段的后面
      if(dub.timeSlot[0] >= ct[1]) {
        dub.timeSlot[0] -= dur;
        dub.timeSlot[1] -= dur;
        continue;
      }
      if(dub.timeSlot[0] <= ct[0] - 0.2) {
        // ---___|___--|---- 在删除时间段前不断
        if(dub.timeSlot[1] >= ct[1] + 0.2) {
          // ---___|____|__---- 横跨在删除时间段
          index = i + 1;
          addDub = {
            title: dub.title,
            id: dub.id,
            fileType: dub.fileType,
            timeSlot: [ct[0], dub.timeSlot[1] - dur],
            cut: [dub.cut[0] + ct[1] - dub.timeSlot[0], dub.cut[1]],
            url: dub.url,
          }
        }
        dub.timeSlot[1] = ct[0]
      } else {
        if(dub.timeSlot[1] < ct[1] + 0.2) {
          // ----|-____-|---- 在删除时间段前之间
          this.delDubbing(i, true);
          i--;
        } else {
          // ----|-_____|__-- 在删除时间段后半段
          dub.cut[0] += (dub.cut[0] + ct[1] - dub.timeSlot[0]);
          dub.timeSlot[0] = ct[0];
          dub.timeSlot[1] -= dur;
        }
      }
    }
    if(index > -1) {
      // 因为删除和分割添加这种情况互斥所以可以直接添加
      this.addDubbing(addDub, index, true)
    }
    this.updateDubbingPlayData();
  }
  addScenesSound(ct, sounds = []) {
    let dub = null;
    let dur = ct[1] - ct[0];
    let insertIndex = 0;
    for(let i = 0; i < this.dubbing.length; i++) {
      dub = this.dubbing[i];
      // ___ |---- 在新增时间段的前面
      if(dub.timeSlot[1] <= ct[0]) {
        insertIndex++;
        continue;
      }
      // -----| ____ 在新增时间段的后面
      if(dub.timeSlot[0] >= ct[0]) {
        dub.timeSlot[0] += dur;
        dub.timeSlot[1] += dur;
        continue;
      }
      if(dub.timeSlot[0] <= ct[0] - 0.2) {
        // ___|___ 在添加时间段前不断
        if(dub.timeSlot[1] >= ct[0] + 0.2) {
          this.addDubbing({
            title: dub.title,
            id: dub.id,
            fileType: dub.fileType,
            timeSlot: [ct[0], dub.timeSlot[1]],
            cut: [dub.cut[0] + ct[0] - dub.timeSlot[0], dub.cut[1]],
            url: dub.url,
          }, i + 1, true)
        }
        dub.timeSlot[1] = ct[0];
        insertIndex++;
      } else {
        if(dub.timeSlot[1] < ct[0]+ 0.2) {
          this.delDubbing(i, true)
          i--;
        } else {
          dub.cut[0] = dub.cut[0] + ct[0] - dub.timeSlot[0];
          dub.timeSlot[0] = ct[1];
          dub.timeSlot[1] += dur;
        }
      }
    }
    if(sounds.length) {
      for(let j = 0; j < sounds.length; j++) {
        this.addDubbing(sounds[j], insertIndex, true);
        insertIndex++;
      }
    }
    this.updateDubbingPlayData();
  }
  swapScenesSound(ct) {
    // 将时间段ct[0]-ct[1] 移动到ct[2]位置
    let dur = ct[1] - ct[0];
    let dub = null;
    let addDubbings = [];
    let addDub = null;
    if(ct[0] < ct[2]) {
      for(let i = 0; i < this.dubbing.length; i++) {
        dub = this.dubbing[i];
        // ___|---|-------|--- (0, 1, 2)
        if(dub.timeSlot[1] < ct[0]) continue;
        // ---|---|--___--|--- (0, 1, 2)
        if(dub.timeSlot[0] >= ct[1] && dub.timeSlot[1] <= ct[2]) {
          dub.timeSlot[0] -= dur
          dub.timeSlot[1] -= dur
          continue;
        }
        // ---|---|-------|___ (0, 1, 2)
        if(dub.timeSlot[0] >= ct[2]) continue;
        addDub = {
          title: dub.title,
          id: dub.id,
          fileType: dub.fileType,
          url: dub.url
        }
        if(dub.timeSlot[0] <= ct[0] - 0.2) {
          if(dub.timeSlot[1] < ct[1] + 0.2) {
            // -__|__-|-------|--- (0, 1, 2)
            if(dub.timeSlot[1] >= ct[0] + 0.2) {
              addDubbings.push(Object.assign({}, addDub, {
                timeSlot:[ct[2]-dur, ct[2]-ct[1]+Math.min(ct[1], dub.timeSlot[1])],
                cut:[dub.cut[0]+ct[0]-dub.timeSlot[0], dub.cut[1]]
              }))
            }
          } else if(dub.timeSlot[1] < ct[2] + 0.2) {
            // -__|___|_____--|--- (0, 1, 2)
            addDubbings.push(Object.assign({}, addDub, {
              timeSlot:[ct[2]-dur, ct[2]],
              cut:[dub.cut[0]+ct[0]-dub.timeSlot[0], dub.cut[1]]
            }))
            if(dub.timeSlot[1] >= ct[1] + 0.2) {
              addDubbings.push(Object.assign({}, addDub, {
                timeSlot:[ct[0], Math.min(dub.timeSlot[1], ct[2])-dur],
                cut:[dub.cut[0] + ct[1]-dub.timeSlot[0], dub.cut[1]]
              }))
            }
          } else if(dub.timeSlot[1] >= ct[2] + 0.2) {
            // -__|___|_______|__- (0, 1, 2)
            addDubbings.push(Object.assign({}, addDub, {
              timeSlot:[ct[2]-dur, ct[2]],
              cut:[dub.cut[0]+ct[0]-dub.timeSlot[0], dub.cut[1]]
            }))
            addDubbings.push(Object.assign({}, addDub, {
              timeSlot:[ct[0], ct[2]-dur],
              cut:[dub.cut[0]+ct[1]-dub.timeSlot[0], dub.cut[1]]
            }))
            addDubbings.push(Object.assign({}, addDub, {
              timeSlot:[ct[2], dub.timeSlot[1]],
              cut:[dub.cut[0]+ct[2]-dub.timeSlot[0], dub.cut[1]]
            }))
          }
          dub.timeSlot[1] = ct[0];
          continue;
        } else if(dub.timeSlot[0] <= ct[1] - 0.2) {
          if(dub.timeSlot[1] >= ct[2] + 0.2) {
            // ---|-__|_______|__- (0, 1, 2)
            addDubbings.push(Object.assign({}, addDub, {
              timeSlot:[ct[0], ct[2]-dur],
              cut: [dub.cut[0]+ct[1]-dub.timeSlot[0], dub.cut[1]]
            }))
            addDubbings.push(Object.assign({}, addDub, {
              timeSlot:[ct[2], dub.timeSlot[1]],
              cut: [dub.cut[0]+ct[2]-dub.timeSlot[0], dub.cut[1]]
            }))
          } else if(dub.timeSlot[1] >= ct[1] + 0.2){
            // ---|-__|______-|--- (0, 1, 2)
            addDubbings.push(Object.assign({}, addDub, {
              timeSlot:[ct[0], Math.min(dub.timeSlot[1], ct[2])-dur],
              cut: [dub.cut[0]+ct[1]-dub.timeSlot[0], dub.cut[1]]
            }))
          }
          if(dub.timeSlot[0] < ct[0]) {
            if(dub.timeSlot[1] < ct[0] + 0.2) {
              this.delDubbing(i, true);
              i--;
              continue;
            }
            dub.cut[0] = dub.cut[0] + ct[0] - dub.timeSlot[0];
            dub.timeSlot[0] = ct[0]
          }
          if(dub.timeSlot[1] > ct[1]) {
            dub.timeSlot[1] = ct[1];
          }
          dub.timeSlot[1] = dub.timeSlot[1] + ct[2] - ct[1];
          dub.timeSlot[0] = dub.timeSlot[0] + ct[2] - ct[1];
        } else if(dub.timeSlot[0] <= ct[2] - 0.2) {
          if(dub.timeSlot[1] >= ct[2] + 0.2) {
            // ---|---|-----__|__- (0, 1, 2)
            addDubbings.push(Object.assign({}, addDub, {
              timeSlot:[ct[2], dub.timeSlot[1]],
              cut: [dub.cut[0]+ct[2]-dub.timeSlot[0], dub.cut[1]]
            }))
          }
          if(dub.timeSlot[0] < ct[1]) {
            if(dub.timeSlot[1] < ct[1] + 0.2) {
              this.delDubbing(i, true);
              i--;
              continue;
            }
            dub.cut[0] = dub.cut[0] + ct[1] - dub.timeSlot[0];
            dub.timeSlot[0] = ct[1];
          }
          if(dub.timeSlot[1] > ct[2]) {
            dub.timeSlot[1] = ct[2];
          }
          dub.timeSlot[0] = dub.timeSlot[0] - dur;
          dub.timeSlot[1] = dub.timeSlot[1] - dur;
        } else if(dub.timeSlot[0] < ct[2]) {
          if(dub.timeSlot[1] < ct[2] + 0.2) {
            this.delDubbing(i, true);
            i--;
            continue;
          }
          dub.cut[0] = dub.cut[0] + ct[2] - dub.timeSlot[0];
          dub.timeSlot[0] = ct[2];
        }
      }
    } else {
      for(let i = 0; i < this.dubbing.length; i++) {
        dub = this.dubbing[i];
        // ___ |-----|----|---- 在移动到位置插入点的前面 对应时间(2, 0, 1)
        if(dub.timeSlot[1] <= ct[2]) continue;
        // ----|_____|----|--- 在移动到位置插入点的后面并在开始移动的前面(2, 0, 1)
        if(dub.timeSlot[0] >= ct[2] && dub.timeSlot[1] <= ct[0]) {
          dub.timeSlot[0] += dur
          dub.timeSlot[1] += dur
          continue;
        }
        // ----|-----|----|____在移动位置的后面不会受到影响(2, 0, 1)
        if(dub.timeSlot[0] >= ct[1]) continue;

        addDub = {
          title: dub.title,
          id: dub.id,
          fileType: dub.fileType,
          url: dub.url
        }
        if(dub.timeSlot[0] <= ct[2] - 0.2) {
          if(dub.timeSlot[1] < ct[0] + 0.2) {
            // ___ |_____|----|----(2, 0, 1)
            if(dub.timeSlot[1] >= ct[2] + 0.2) {
              addDubbings.unshift(Object.assign({}, addDub, {
                timeSlot: [ct[2]+dur, Math.min(dub.timeSlot[1],ct[0])+dur], // 超出的部分需要截取掉
                cut: [dub.cut[0] + ct[2] - dub.timeSlot[0], dub.cut[1]],
              }))
            }
          } else if(dub.timeSlot[1] < ct[1] + 0.2) {
            // ___ |_____|____|----(2, 0, 1)
            addDubbings.unshift(Object.assign({}, addDub, {
              timeSlot: [ct[2]+dur, ct[0]+dur],
              cut: [dub.cut[0]+ct[2]-dub.timeSlot[0], dub.cut[1]],
            }))
            if(dub.timeSlot[1] >= ct[0] + 0.2) {
              addDubbings.unshift(Object.assign({}, addDub, {
                timeSlot:[ct[2], ct[2]-ct[0]+Math.min(dub.timeSlot[1], ct[1])],
                cut: [dub.cut[0]+ct[0]-dub.timeSlot[0], dub.cut[1]]
              }))
            }
          } else if(dub.timeSlot[1] >= ct[1] + 0.2) {
            // ____|_____|____|____(2, 0, 1)
            addDubbings.unshift(Object.assign({}, addDub, {
              timeSlot: [ct[2]+dur, ct[0]+dur],
              cut: [dub.cut[0]+ct[2]-dub.timeSlot[0], dub.cut[1]],
            }))
            addDubbings.unshift(Object.assign({}, addDub, {
              timeSlot:[ct[2], ct[2]+dur],
              cut: [dub.cut[0]+ct[0]-dub.timeSlot[0], dub.cut[1]]
            }))
            addDubbings.push(Object.assign({}, addDub, {
              timeSlot:[ct[1], dub.timeSlot[1]],
              cut: [dub.cut[0]+ct[1]-dub.timeSlot[0], dub.cut[1]]
            }))
          }
          dub.timeSlot[1] = ct[2];
          continue;
        } else if(dub.timeSlot[0] <= ct[0] - 0.2) {
          if(dub.timeSlot[1] >= ct[1] + 0.2) {
            // -----|-____|____|____- (2, 0, 1)
            addDubbings.push(Object.assign({}, addDub, {
              timeSlot:[ct[2], ct[2]+dur],
              cut: [dub.cut[0]+ct[0]-dub.timeSlot[0], dub.cut[1]]
            }))
            addDubbings.push(Object.assign({}, addDub, {
              timeSlot:[ct[1], dub.timeSlot[1]],
              cut: [dub.cut[0]+ct[1]-dub.timeSlot[0], dub.cut[1]]
            }))
          } else if(dub.timeSlot[1] >= ct[0] + 0.2) {
            // -----|--___|____|---- (2, 0, 1)
            addDubbings.push(Object.assign({}, addDub, {
              timeSlot:[ct[2], ct[2]-ct[0]+Math.min(dub.timeSlot[1], ct[1])],
              cut: [dub.cut[0]+ct[0]-dub.timeSlot[0], dub.cut[1]]
            }))
          }
          if(dub.timeSlot[0] < ct[2]) {
            if(dub.timeSlot[1] < ct[2] + 0.2) {
              this.delDubbing(i, true);
              i--;
              continue;
            }
            dub.cut[0] = dub.cut[0] + ct[2] - dub.timeSlot[0];
            dub.timeSlot[0] = ct[2];
          }
          if(dub.timeSlot[1] > ct[0]) {
            dub.timeSlot[1] = ct[0];
          }
          dub.timeSlot[1] += dur;
          dub.timeSlot[0] += dur;
        } else if(dub.timeSlot[0] <= ct[1] - 0.2) {
          if(dub.timeSlot[1] >= ct[1] + 0.2) {
            // -----|-----|___|____- (2, 0, 1)
            addDubbings.push(Object.assign({}, addDub, {
              timeSlot: [ct[1], dub.timeSlot[1]],
              cut: [dub.cut[0]+ct[1]-dub.timeSlot[0], dub.cut[1]]
            }))
          }
          if(dub.timeSlot[0] < ct[0]) {
            if(dub.timeSlot[1] < ct[1] + 0.2) {
              this.delDubbing(i, true);
              i--;
              continue;
            }
          }
          dub.timeSlot[0] = dub.timeSlot[0] - ct[0] + ct[2];
          dub.timeSlot[1] = dub.timeSlot[1] - ct[0] + ct[2];
          if(dub.timeSlot[0] < ct[2]) {
            dub.cut[0] = dub.cut[0] + ct[2] - dub.timeSlot[0];
            dub.timeSlot[0] = ct[2];
          }
          if(dub.timeSlot[1] > ct[2]+dur) {
            dub.timeSlot[1] = ct[2] + dur;
          }
        } else if(dub.timeSlot[0] < ct[1]) {
          if(dub.timeSlot[1] < ct[1] + 0.2) {
            this.delDubbing(i, true);
            i--;
            continue;
          }
          dub.cut[0] = dub.cut[0] + ct[1] - dub.timeSlot[0]
          dub.timeSlot[0] = ct[1]
        }
      }
    }
    addDub = null;
    for(let i = 0; i < addDubbings.length; i++) {
      this.addDubbing(addDubbings[i])
    }
    this.dubbing.sort(function(a, b) {
      return a.timeSlot[0] - b.timeSlot[0];
    })
    this.updateDubbingPlayData();
  }
  changeScenesTime(tn, ct, tt) {
    // tn 改变之前的时间点 ct 改变的时长 tt 改变前的总时长
    let dub = null;
    for(let i = 0;i < this.dubbing.length; i++) {
      dub = this.dubbing[i];
      if(ct > 0) {
        if(dub.timeSlot[1].toFixed(3) === tn.toFixed(3)) {
          dub.timeSlot[1] = Math.min(tn + ct, dub.timeSlot[0] + dub.cut[1]-dub.cut[0]);
          continue;
        }
      }
      if(dub.timeSlot[1] <= tn + ct) continue;
      if(ct < 0) {
        if(dub.timeSlot[0] > tn + ct - 0.2 && dub.timeSlot[0] < tn) {
          this.delDubbing(i, true);
          i--;
          continue;
        }
        if(dub.timeSlot[0] <= tn + ct - 0.2 && dub.timeSlot[1] > tn + ct) {
          let minTime = 0;
          if(this.dubbing[i+1]) {
            minTime = this.dubbing[i+1].timeSlot[0] + ct;
          } else {
            minTime = tt + ct;
          }
          dub.timeSlot[1] = Math.min(minTime, dub.timeSlot[1]);
          continue;
        }
      }
      if(dub.timeSlot[0] >= tn) {
        dub.timeSlot[0] += ct;
        dub.timeSlot[1] += ct;
      }
    }
    this.updateDubbingPlayData();
  }
  getDubbingTS(ts) {
    let dub = null;
    let dubbingArr = [];
    for(let i in this.dubbing) {
      dub = this.dubbing[i];
      if(dub.timeSlot[1] < ts[0]+ 0.2) continue;
      if(dub.timeSlot[0] > ts[1] - 0.2) break;
      if(dub.timeSlot[0] < ts[0]) {
        if(dub.timeSlot[1] >= ts[1]) {
          dubbingArr.push({
            title: dub.title,
            resourceId: dub.id,
            type: 1,
            fileType: dub.fileType,
            url: dub.url,
            timeSlot: [0, +(ts[1]-ts[0]).toFixed(3)],
            cut: [+(dub.cut[0]+ts[0]-dub.timeSlot[0]).toFixed(3), + dub.cut[1].toFixed(3)]
          })
          break;
        } else if(dub.timeSlot[1] >= ts[0] + 0.2) {
          dubbingArr.push({
            title: dub.title,
            resourceId: dub.id,
            type: 1,
            fileType: dub.fileType,
            url: dub.url,
            timeSlot: [0, + (dub.timeSlot[1] - ts[0]).toFixed(3)],
            cut: [+(dub.cut[0]+ts[0]-dub.timeSlot[0]).toFixed(3), + dub.cut[1].toFixed(3)]
          })
          continue;
        }
      } else if(dub.timeSlot[0] <= ts[1] + 0.2) {
        dubbingArr.push({
          title: dub.title,
          resourceId: dub.id,
          type: 1,
          fileType: dub.fileType,
          url: dub.url,
          timeSlot: [+(dub.timeSlot[0] - ts[0]).toFixed(3), + (Math.min(dub.timeSlot[1], ts[1])-ts[0]).toFixed(3)],
          cut: dub.cut.map(v => {return + v.toFixed(3)}),
        })
        continue;
      }
    }
    if(dubbingArr.length) {
      return dubbingArr
    } else {
      return null
    }
  }
  updateScenesSound(ct, sounds = []) {
    // [开始点, 原始点, 变化点]
    let dt = ct[2] - ct[1];
    let dub = null;
    for(let i = 0; i < this.dubbing.length; i++) {
      dub = this.dubbing[i];
      if(dub.timeSlot[1] <= ct[0]) continue;
      if(dub.timeSlot[0] >= ct[1]) {
        dub.timeSlot[0] += dt;
        dub.timeSlot[1] += dt;
        continue;
      }
      if(dub.timeSlot[0] <= ct[0] - 0.2){
        if(dub.timeSlot[1] >= ct[1] + 0.2) {
          sounds.push({
            title: dub.title,
            id: dub.id,
            fileType: dub.fileType,
            url: dub.url,
            timeSlot:[ct[2], dub.timeSlot[1] + dt],
            cut:[dub.cut[0] + ct[1] - dub.timeSlot[0], dub.cut[1]]
          })
        }
        dub.timeSlot[1] = ct[0];
      } else if(dub.timeSlot[0] < ct[1]) {
        if(dub.timeSlot[1] >= ct[1] + 0.2) {
          dub.cut[0] = dub.cut[0] + ct[1] - dub.timeSlot[0]
          dub.timeSlot[0] = ct[2];
          dub.timeSlot[1] += dt;
        } else {
          this.delDubbing(i, true);
          i--;
          continue;
        }
      }
    }
    if(sounds.length) {
      for(let i = 0; i < sounds.length; i++) {
        this.addDubbing(sounds[i], null, true)
      }
      this.dubbing.sort(function(a, b) {
        return a.timeSlot[0] - b.timeSlot[0];
      })
    }
    this.updateDubbingPlayData();
  }
  insertScenesArrSound(ct, music = []) {
    this.addScenesSound(ct);
    if(music.length) {
      let m = null;
      let index = 0;
      let canAdd = true;
      for(let i = 0; i < this.music.length; i++) {
        m = this.music[i];
        if(m.timeSlot[1] <= ct[0]) {
          index++;
          continue;
        }
        if(m.timeSlot[0] < ct[0] && m.timeSlot[1] > ct[0]) {
          canAdd = false;
          break;
        }
        if(m.timeSlot[0] >= ct[0]) break;
      }
      if(canAdd) {
        for(let i = index; i < this.music.length; i++) {
          this.music[i].timeSlot[0] += (ct[1] - ct[0]);
          this.music[i].timeSlot[1] += (ct[1] - ct[0]);
        }
        for(let i = 0; i < music.length; i++) {
          this.addMusic(music[i], index, true);
          index++;
        }
      }
      this.updateMusicPlayData();
    }
  }
  coverScenesArrSound(tt, music) {
    this.clearSound('dubbing');
    if(music && music.length) {
      this.clearSound('music');
      for(let i = 0; i < music.length; i++) {
        this.addMusic(music[i], null, true);
      }
      this.updateMusicPlayData()
    } else {
      for(let i = 0; i < this.music.length; i++) {
        if(this.music[i].timeSlot[1] <= tt) continue;
        if(this.music[i].timeSlot[0] <= tt - 0.2 && this.music[i].timeSlot[1] > tt) {
          this.music[i].timeSlot[1] = tt;
          continue;
        }
        if(this.music[i].timeSlot[0] > tt - 0.2) {
          this.delMusic(i, true);
          i--;
        }
      }
      this.updateMusicPlayData();
    }
  }
}

export default SoundPlayHandle;




//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/soundPlay.js
// module id = null
// module chunks = 